import { apiBaseCMSWithToken } from "../services/axiosBase"

export const getAllAddressData = async () => {
    try {
      const [citiesRes, districtsRes, townsRes] = await Promise.all([
        apiBaseCMSWithToken.get('/api/v1/address/city'),
        apiBaseCMSWithToken.get('/api/v1/address/district/all'),
        apiBaseCMSWithToken.get('/api/v1/address/town/all'),
      ])
  
      return {
        cities: citiesRes?.data?.list || [],
        districts: districtsRes?.data?.list || [],
        towns: townsRes?.data?.list || [],
      }
    } catch (error) {
      console.error('Error fetching all address data:', error)
      throw error
    }
  }